import React from 'react'

import { useOperatorNotification } from '@contexts/operator/OperatorNotificationContext'
import ShelfMovementsList from '@shared/shelf_movements/ShelfMovementsList'
import ListPageHeader from '@shared/ListPageHeader'

import { inventoryTypeService } from '@services/operator/inventoryTypeService'
import { shelfMovementService } from '@services/operator/shelfMovementService'

export default function OperatorShelfMovementsList() {
  const { addJob } = useOperatorNotification()

  return (
    <div>
      <ListPageHeader items={['stocks', 'stocks.shelf_movements']} />
      <ShelfMovementsList
        service={shelfMovementService}
        inventoryTypeService={inventoryTypeService}
        role="operator"
        addJob={addJob}
      />
    </div>
  )
}
